export default "__VITE_PUBLIC_ASSET__cb9006dc__"